import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  LightpathRedundantSubscriptionDetailsGQL,
  LightpathRedundantSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { LightPathRedundantSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { LightpathSubscriptionView } from "./lightpath-subscription-view";

@Component({
  selector: "lightpath-redundant-subscription",
  templateUrl: "lightpath-redundant-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LightpathSubscriptionView, SubscriptionPageComponent],
})
export class LightpathRedundantSubscriptionComponent extends GenericSubscription<
  LightpathRedundantSubscriptionDetailsQuery,
  LightPathRedundantSubscriptionDetails
> {
  protected query = inject(LightpathRedundantSubscriptionDetailsGQL);

  protected onQuerySuccess(data: LightpathRedundantSubscriptionDetailsQuery): LightPathRedundantSubscriptionDetails {
    return data.lrDetails;
  }
}
